import { Portal } from '@mui/material';
import { useEffect } from 'react';

const AriaPersistentContainer = ({ children }) => {
  const root = document.getElementById('aria-announcer');

  useEffect(() => {
    if (!root) {
      console.error("AriaPersistentContainer couldn't find the element.");
      return;
    }

    const observer = new MutationObserver(() => {
      if (root.getAttribute('aria-hidden')) {
        root.removeAttribute('aria-hidden');
      }
    });

    observer.observe(root, {
      attributeFilter: ['aria-hidden'],
    });

    return () => {
      observer.disconnect();
    };
  }, [root]);

  return <Portal container={root}>{children}</Portal>;
};
export default AriaPersistentContainer;
